import { BaseFeature, FeatureType } from '@core/shared/feature';
export class PflegethekeAppBaseFeature extends BaseFeature {
  static {
    this.featureInfo = {
      dependencies: ['common-task-scheduler'],
      context: {"package":"@pflegetheke/app/feature","featureId":"pflegetheke-app"},
      abilityActions: false,
      plugins: [{
        forPlatform: 'frontend',
        type: FeatureType.Permanent,
        pluginClassName: 'PflegethekeAppFrontendFeature'
      }, {
        forPlatform: 'admin',
        type: FeatureType.Permanent,
        pluginClassName: 'PflegethekeAppFrontendAdminFeature'
      }
      // {forPlatform:'backend', type:FeatureType.Permanent, pluginClassName:'PflegethekeAppBackendFeature'},
      ]
    };
  }
  getSharedDefinition() {
    return {};
  }
}